@if (qualificationDetails) {
  <nz-collapse [nzBordered]="false" nzGhost>
    <nz-collapse-panel
      #userPanel
      class="collapse-panel"
      [nzHeader]="qualificationInfoSectionHeader"
      [nzActive]="true"
      [nzShowArrow]="true"
    >
      <div class="details-grid">
        <div class="info-row">
          <span class="info-label">
            {{ 'page.qualifications.user' | translate }}:
          </span>
          <span class="info-value ms-3">
            {{
              employee
                ? employee.firstName + ' ' + employee.lastName
                : ('general.n/a' | translate)
            }}
          </span>
        </div>

        @if (sharedQualiPartnerName) {
          <div class="info-row">
            <span class="info-label">
              {{ 'page.qualifications.partner' | translate }}:
            </span>
            <span class="info-value ms-3">
              {{ sharedQualiPartnerName }}
            </span>
          </div>
        }

        <div class="info-row">
          <span class="info-label">
            {{ 'page.qualifications.drawer.certificate' | translate }}:
          </span>
          <span class="info-value ms-3">
            {{
              qualificationDetails.qualification
                ? (qualificationDetails.qualification | qualificationV2NameSync)
                : ''
            }}
          </span>
        </div>

        @if (qualificationDetails.acquiredAt) {
          <div class="info-row">
            <span class="info-label">
              {{ 'general.acquired_at' | translate }}:
            </span>
            <span class="info-value ms-3">
              {{
                qualificationDetails.acquiredAt
                  | dfnsParseIso
                  | localizedDateFormat
              }}
            </span>
          </div>
        }
        @if (qualificationDetails.validFrom) {
          <div class="info-row">
            <span class="info-label">
              {{ 'general.valid_from' | translate }}:
            </span>
            <span class="info-value ms-3">
              {{
                qualificationDetails.validFrom
                  | dfnsParseIso
                  | localizedDateFormat
              }}
            </span>
          </div>
        }
        @if (qualificationDetails.validTill) {
          <div class="info-row">
            <span class="info-label">
              {{ 'general.valid_until' | translate }}:
            </span>
            <span class="info-value ms-3">
              {{ qualificationDetails | userQualificationV2TransformValidTill }}
            </span>
          </div>
        }
        <div class="info-row">
          <span class="info-label info-label--wrap">
            {{ 'page.qualifications.drawer.confirmed_by_user' | translate }}:
          </span>
          <span class="info-value ms-3">
            {{
              qualificationDetails.confirmedByUser
                ? ('page.qualifications.drawer.confirmed' | translate)
                : ('page.qualifications.drawer.not_confirmed' | translate)
            }}
          </span>
        </div>
        @if (qualiLastEdited) {
          <div class="info-row">
            <span class="info-label info-label--wrap">
              {{ 'general.last_edit' | translate }}
            </span>
            <span class="info-value ms-3">
              @if (qualiLastEdited.updatedAt) {
                {{
                  (qualiLastEdited.updatedAt
                    | dfnsParseIso
                    | localizedDateTimeFormat) +
                    ' - ' +
                    (qualiLastEdited.updatedById | userName | async)
                }}
              } @else if (qualiLastEdited.createdAt) {
                {{
                  (qualiLastEdited.createdAt
                    | dfnsParseIso
                    | localizedDateTimeFormat) +
                    ' - ' +
                    (qualiLastEdited.createdById | userName | async)
                }}
              } @else {
                {{ 'general.n/a' | translate }}
              }
            </span>
          </div>
        }
        <div class="info-row">
          <span class="info-label info-label--wrap">
            {{ 'general.note' | translate }}
          </span>
          <span class="info-value ms-3">
            {{ qualificationDetails.notes }}
          </span>
        </div>
      </div>
    </nz-collapse-panel>

    <ng-template #qualificationInfoSectionHeader>
      <div class="d-flex justify-content-between">
        <span class="header-text">
          {{ 'general.title' | translate }}
        </span>
      </div>
    </ng-template>
  </nz-collapse>
}
